import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import emailjs from "@emailjs/browser";

const AppointmentS2 = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    approx: "",
    bedrooms: "",
    bathrooms: "",
    zCode: "",
    message: "",
  });
  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      validator.hideMessages();

      // Send email
      emailjs
        .send(
          "service_ozsx57f",
          "template_w6uj6im",
          {
            from_name: forms.name,
            from_email: forms.email,
            phone: forms.phone,
            subject: forms.subject,
            message: forms.message,
          },
          "Y3xjlBaVABiCV6XUx"
        )
        .then(
          (response) => {
            alert("Thank you. we will get back to you as soon as possible.");
            console.log("Email sent successfully:", response);
            // Clear the form after successful submission
            setForms({
              name: "",
              email: "",
              subject: "",
              phone: "",
              approx: "",
              bedrooms: "",
              bathrooms: "",
              zCode: "",
              message: "",
            });
          },
          (error) => {
            alert("Ahh, something went wrong. Please try again.");
            console.error("Email send failed:", error);
          }
        );
    } else {
      validator.showMessages();
    }
  };
  return (
    <section className="wpo-contact-section-s2 section-padding">
      <div className="container">
        <div className="wpo-contact-section-wrapper">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 col-md-12 col-12">
              <div className="wpo-contact-form-area">
                <div className="wpo-section-title">
                  <h2>Maak een afspraak</h2>
                </div>
                <form
                  onSubmit={(e) => submitHandler(e)}
                  className="contact-validation-active"
                >
                  <div className="row">
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.name}
                          type="text"
                          name="name"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Je Naam"
                        />
                      </div>
                      {validator.message(
                        "name",
                        forms.name,
                        "required|alpha_space"
                      )}
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.email}
                          type="email"
                          name="email"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Je E-mail"
                        />
                        {validator.message(
                          "email",
                          forms.email,
                          "required|email"
                        )}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <select
                          className="form-control"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          value={forms.subject}
                          type="text"
                          name="subject"
                        >
                          <option>Kies een Dienst</option>
                          <option>Residentiële Schoonmaak</option>
                          <option>Commerciële Schoonmaak</option>
                          <option>Kantoor Schoonmaak</option>
                          <option>Thuis Schoonmaak</option>
                          <option>Winkel Schoonmaak</option>
                          <option>Weg Schoonmaak</option>
                          <option>Auto Schoonmaak</option>
                        </select>
                        {validator.message(
                          "subject",
                          forms.subject,
                          "required"
                        )}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <select
                          className="form-control"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          value={forms.approx}
                          type="text"
                          name="approx"
                        >
                          <option>-- Approx SF --</option>
                          <option>&lt;900</option>
                          <option>800</option>
                          <option>700</option>
                          <option>600</option>
                          <option>&gt;500</option>
                        </select>
                        {validator.message("approx", forms.approx, "required")}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <select
                          className="form-control"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          value={forms.bedrooms}
                          type="text"
                          name="bedrooms"
                        >
                          <option>Residentieel</option>
                          <option>Commercieel</option>
                          <option>Appartement</option>
                        </select>
                        {validator.message(
                          "bedrooms",
                          forms.bedrooms,
                          "required"
                        )}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <select
                          className="form-control"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          value={forms.bathrooms}
                          type="text"
                          name="bathrooms"
                        >
                          <option>Residentieel</option>
                          <option>Commercieel</option>
                          <option>Appartement</option>
                        </select>
                        {validator.message(
                          "bathrooms",
                          forms.bathrooms,
                          "required"
                        )}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          value={forms.phone}
                          type="phone"
                          name="phone"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          placeholder="Uw telefoonnummer"
                        />
                        {validator.message(
                          "phone",
                          forms.phone,
                          "required|phone"
                        )}
                      </div>
                    </div>
                    <div className="col col-lg-6 col-12">
                      <div className="form-field">
                        <input
                          className="form-control"
                          onBlur={(e) => changeHandler(e)}
                          onChange={(e) => changeHandler(e)}
                          value={forms.zCode}
                          type="text"
                          name="zCode"
                          placeholder="Postcode"
                        />
                      </div>
                      {validator.message("Zip Code", forms.zCode, "required")}
                    </div>
                    <div className="col fullwidth col-lg-12 ">
                      <textarea
                        className="form-control"
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                        value={forms.message}
                        type="text"
                        name="message"
                        placeholder="Bericht"
                      ></textarea>
                      {validator.message("message", forms.message, "required")}
                    </div>
                  </div>
                  <div className="submit-area">
                    <button type="submit" className="theme-btn">
                      <i
                        className="fa fa-angle-double-right"
                        aria-hidden="true"
                      ></i>{" "}
                      Verzenden
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentS2;
